import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
export function useScrollHasStarted() {
  const $ = _c(2);
  const [scrollHasStarted, setScrollHasStarted] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const handleScroll = () => {
        setScrollHasStarted(window.scrollY > 0);
      };
      handleScroll();
      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  return scrollHasStarted;
}